import { useMutation } from '@apollo/client/react';
import classNames from 'classnames';
import React, { useState } from 'react';

import FormBlock from '~/shared/components/form-block';
import { getFreeConsultationFormConfig } from '~/shared/configs/forms';
import { CONSULTATION_TYPE } from '~/shared/constants';
import { createOneConsultationMutation } from '~/shared/graphql-queries/consultations';
import { useTypedTranslation } from '~/shared/hooks';
import { useAppDispatch } from '~/shared/store/hooks';
import { changeStateOfConfirmModal } from '~/shared/store/slices/app/app-slice';

import './small-request-form.scss';

const SmallRequestForm = ({ type = CONSULTATION_TYPE.COURSE }) => {
  const t = useTypedTranslation(['text', 'modal', 'button', 'field']);
  const formConfig = getFreeConsultationFormConfig({ t });
  const [isResetForm, setIsResetForm] = useState(false);
  const [consultationCreateMutation] = useMutation(createOneConsultationMutation);
  const dispatch = useAppDispatch();

  const modalTitle = t('modal.confirmation-contacts-request-form.title', {
    ns: ['modal'],
  });
  const modalMessage = t('modal.confirmation-contacts-request-form.message', {
    ns: ['modal'],
  });
  const onSubmit = async ({ userName, phone, entity = null }: { userName; phone }) => {
    dispatch(
      changeStateOfConfirmModal({
        onTrigger: async (itemKey) => {
          await consultationCreateMutation({
            variables: {
              record: {
                userName,
                type,
                entity,
                phone: `${phone?.countryCode}${phone?.areaCode}${phone?.phoneNumber}`,
              },
            },
          });
          setIsResetForm(true);
        },
        title: modalTitle,
        message: (
          <div className="styled-modal">
            <div className="small-request-form__content">
              <div className="small-request-form__description-container">{modalMessage}</div>
              <div className="small-request-form__info">
                <div className="small-request-form__info-item">
                  <span className="small-request-form__info-item-label">
                    {t('text.name', {
                      ns: ['text'],
                    })}
                    :
                  </span>
                  <span>{userName}</span>
                </div>
                <div className="small-request-form__info-item">
                  <span className="small-request-form__info-item-label">
                    {t('text.phone', {
                      ns: ['text'],
                    })}
                    :
                  </span>
                  <span>{`+${phone?.countryCode}${phone?.areaCode}${phone?.phoneNumber}`}</span>
                </div>
              </div>
            </div>
          </div>
        ),
        isShowed: true,
      }),
    );
  };

  return (
    <div className={classNames('container', 'small-request-form')}>
      <section className="small-request-form">
        <div className="small-request-form__content">
          <h2 className="small-request-form__title">{t('text.want-to-get')}</h2>
          <p className="small-request-form__description">{t('text.we-will-call-and-consult')}</p>
          <FormBlock initialValues={formConfig.initialValues} formConfig={formConfig} onSubmit={onSubmit} />
        </div>
      </section>
    </div>
  );
};

export default SmallRequestForm;
